import React from 'react';

import TabStrip from '~/components/Offers/Detail/OfferBuilder/shared/TabStrip';

import { usePricingToolTabCounts } from './PricingToolTabCounts';
import { PRICING_TOOL_TABS } from './constants';
import type { PricingToolTab } from './types';

interface Props {
  activeTab: PricingToolTab;
  onTabChange: (tab: PricingToolTab) => void;
}

export default function PricingToolToolbar({ activeTab, onTabChange }: Props) {
  const counts = usePricingToolTabCounts();

  return <TabStrip activeTab={activeTab} counts={counts} onTabChange={onTabChange} tabs={PRICING_TOOL_TABS} />;
}
